import { useEffect, useState } from "react";
import "../../pages/navbar.css";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Link,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Modal from "react-bootstrap/Modal";
import { FaRegWindowClose } from "@react-icons/all-files/fa/FaRegWindowClose";
import { useNavigate, useLocation } from "react-router-dom";
import { userAccountData, userProfileData } from "../../Common/profileInfo";
import { clientConfig } from "../../awsClientConfig";
import { GetPaymentMethodsByAccount } from "../../queries/GetPaymentMethodsByAccount";
import { UpdatePaymentMethod } from "../../queries/UpdatePaymentMethod";
import Loading from "../../Common/Loading";
import { fetchQuery } from "../../functions/misc";
import { GetProtectionPlanSubscription } from "../../queries/GetProtectionPlanSubscription";
import { ReactComponent as CircleCheck } from '../../assets/circle-check-fill-green.svg';
import { paths } from "../../paths";
import { FeatureFlags } from "../../types/featureFlags";
import { useFlags } from "launchdarkly-react-client-sdk";
import Footer from "../footer";
import AppBreadcrumbs from "../AppBreadCrumbs";

function ClientBillingInformation() {
  const navigate = useNavigate();
  const client = new clientConfig();
  let { state } = useLocation();
  const [savedCards, setSavedCards] = useState<any>([]);
  const [cardSelected, setCardSelected] = useState<any>();
  const [show, setShow] = useState(false);
  const [view, setView] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDefaultErrorModal, setShowDefaultErrorModal] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseView = () => setView(false);
  const handleShowView = () => setView(true);
  const handleCloseDefaultErrorModal = () => setShowDefaultErrorModal(false);
  const [subscriptionInfo, setSubscriptionInfo] = useState<any>();
  const flagList: FeatureFlags = useFlags();

  useEffect(() => {
    getCompleteBillingData();

  }, []);


  const getCompleteBillingData = async () => {
    setLoading(true);
    try {
      const profileId = await userProfileData();
      const getSubscription = await fetchQuery({ ProfileId: profileId }, GetProtectionPlanSubscription);
      setSubscriptionInfo(getSubscription);
      await getCardsSaved();
      //implement payment history API
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }


  const getCardsSaved = async () => {
    const AccountId = await userAccountData();
    client
      .query({
        query: GetPaymentMethodsByAccount,
        variables: { AccountId: AccountId, Domain: "ProtectionPlan" },
      })
      .then((res: any) => {
        setSavedCards(res.data.GetPaymentMethodsByAccount.PaymentMethods);
        setLoading(false);
      })
      .catch((error: any) => {
        console.log(error, "error");
      });
  };

  const checkDateValidity = (cardCheck: any) => {
    const b = cardCheck.CcExpMonth;
    const c = cardCheck.CcExpYear;
    var d1 = new Date(c, +b - 1);
    var today = new Date();
    if (d1 > today) {
      return true;
    } else {
      return false;
    }
  };

  const makeCardDefault = (savedCard: any) => {
    setCardSelected(savedCard);
    handleShow();
  };

  const makeCardDeactivate = (savedCard: any) => {
    if (savedCard?.Default) {
      setShowDefaultErrorModal(true);
    } else {
      setCardSelected(savedCard);
      handleShowView();
    }
  };
  const saveDefaultCard = () => {
    handleClose();
    const variables = {
      ...cardSelected,
      Default: true,
    };
    client
      .mutate({ mutation: UpdatePaymentMethod, variables: variables })
      .then((res: any) => {
        if (res.data.UpdatePaymentMethod) {
          setSaved(true);
          getCardsSaved();
          setTimeout(() => {
            setSaved(false);
          }, 5000);
        }
      })
      .catch(() => { });
  };

  const saveDeactivateCard = () => {
    handleCloseView();
    const variables = {
      ...cardSelected,
      Active: false,
    };
    client
      .mutate({ mutation: UpdatePaymentMethod, variables: variables })
      .then((res: any) => {
        if (res.data.UpdatePaymentMethod) {
          setSaved(true);
          getCardsSaved();
          setTimeout(() => {
            setSaved(false);
          }, 5000);
        }
      })
      .catch(() => { });
  };

  return (
    <div className="page-container">
      <Container className="mb-5 creditcard d-flex justify-content-center">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              width: "80%",
            }}
          >
            <Box className="headerTitleBox">
              <h1 className="headerTitle">
                Billing
              </h1>
              <AppBreadcrumbs
                items={[
                  { label: 'Home', onClick: () => navigate('/dashboard') },
                  { label: 'Account Settings' },
                  { label: 'Billing' }
                ]}
              />
            </Box>

            {loading ? (
              <Loading />
            ) : (
              <Box className="formContainerBox">
                <Box sx={{ py: 4, px: { xs: 2, sm: 4, md: 4, lg: 4 } }}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      color: "#212636",
                      fontSize: "15px",
                      mb: 2
                    }}
                  >
                    Optima Tax Shield Subscription
                  </Typography>

                  {subscriptionInfo && (
                    <Typography sx={{ fontSize: "12px", mb: 3 }}>
                      Tax Shield <b>{subscriptionInfo?.ProtectionPlanName} Plan</b>
                      <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <Card sx={{ borderRadius: 1 }}>
                            <CardContent sx={{ m: 2, p: 0, '&:last-child': { paddingBottom: 0 } }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography sx={{ fontSize: '9px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                                  {subscriptionInfo?.ProtectionPlanName} Plan
                                </Typography>
                                <button
                                  className="btn-outline-no-fill"
                                  onClick={() => navigate(paths.settings.myaccount.changePlan)}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 19 19" fill="none" style={{ marginRight: '0.1rem' }}>
                                    <path d="M9.60352 2.1875C8.15724 2.1875 6.74345 2.61637 5.54091 3.41988C4.33838 4.22339 3.40112 5.36544 2.84765 6.70163C2.29418 8.03781 2.14937 9.50811 2.43153 10.9266C2.71368 12.3451 3.41013 13.648 4.4328 14.6707C5.45547 15.6934 6.75843 16.3898 8.17692 16.672C9.59541 16.9541 11.0657 16.8093 12.4019 16.2559C13.7381 15.7024 14.8801 14.7651 15.6836 13.5626C16.4871 12.3601 16.916 10.9463 16.916 9.5C16.914 7.56123 16.1429 5.70246 14.772 4.33154C13.4011 2.96063 11.5423 2.18955 9.60352 2.1875ZM9.60352 15.6875C8.37975 15.6875 7.18346 15.3246 6.16593 14.6447C5.1484 13.9648 4.35533 12.9985 3.88701 11.8679C3.4187 10.7372 3.29616 9.49314 3.53491 8.29288C3.77366 7.09262 4.36296 5.99011 5.2283 5.12478C6.09363 4.25944 7.19614 3.67014 8.3964 3.43139C9.59665 3.19264 10.8408 3.31518 11.9714 3.7835C13.102 4.25181 14.0683 5.04488 14.7482 6.06241C15.4281 7.07994 15.791 8.27623 15.791 9.5C15.7892 11.1405 15.1367 12.7132 13.9767 13.8732C12.8167 15.0331 11.244 15.6856 9.60352 15.6875ZM12.9785 9.5C12.9785 9.64918 12.9193 9.79226 12.8138 9.89775C12.7083 10.0032 12.5652 10.0625 12.416 10.0625H10.166V12.3125C10.166 12.4617 10.1068 12.6048 10.0013 12.7102C9.89578 12.8157 9.7527 12.875 9.60352 12.875C9.45433 12.875 9.31126 12.8157 9.20577 12.7102C9.10028 12.6048 9.04102 12.4617 9.04102 12.3125V10.0625H6.79102C6.64183 10.0625 6.49876 10.0032 6.39327 9.89775C6.28778 9.79226 6.22852 9.64918 6.22852 9.5C6.22852 9.35082 6.28778 9.20774 6.39327 9.10225C6.49876 8.99676 6.64183 8.9375 6.79102 8.9375H9.04102V6.6875C9.04102 6.53832 9.10028 6.39524 9.20577 6.28975C9.31126 6.18426 9.45433 6.125 9.60352 6.125C9.7527 6.125 9.89578 6.18426 10.0013 6.28975C10.1068 6.39524 10.166 6.53832 10.166 6.6875V8.9375H12.416C12.5652 8.9375 12.7083 8.99676 12.8138 9.10225C12.9193 9.20774 12.9785 9.35082 12.9785 9.5Z" fill="#434A60" />
                                  </svg> Change Plan
                                </button>
                              </Box>
                              <Box sx={{ display: 'flex', gap: 1, mt: 3 }}>
                                <Typography variant="h5">
                                  ${subscriptionInfo?.Amount}
                                </Typography>
                                <Typography color="text.secondary" variant="body2" sx={{ paddingTop: '0.3rem', marginLeft: 0 }}>
                                  /mo
                                </Typography>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </Typography>
                  )}

                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <button
                        className="btn-outline-no-fill"
                        onClick={() => { navigate("/account-settings-payment-add"); }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 19 19" fill="none" style={{ marginRight: '0.1rem' }}>
                          <path d="M9.60352 2.1875C8.15724 2.1875 6.74345 2.61637 5.54091 3.41988C4.33838 4.22339 3.40112 5.36544 2.84765 6.70163C2.29418 8.03781 2.14937 9.50811 2.43153 10.9266C2.71368 12.3451 3.41013 13.648 4.4328 14.6707C5.45547 15.6934 6.75843 16.3898 8.17692 16.672C9.59541 16.9541 11.0657 16.8093 12.4019 16.2559C13.7381 15.7024 14.8801 14.7651 15.6836 13.5626C16.4871 12.3601 16.916 10.9463 16.916 9.5C16.914 7.56123 16.1429 5.70246 14.772 4.33154C13.4011 2.96063 11.5423 2.18955 9.60352 2.1875ZM9.60352 15.6875C8.37975 15.6875 7.18346 15.3246 6.16593 14.6447C5.1484 13.9648 4.35533 12.9985 3.88701 11.8679C3.4187 10.7372 3.29616 9.49314 3.53491 8.29288C3.77366 7.09262 4.36296 5.99011 5.2283 5.12478C6.09363 4.25944 7.19614 3.67014 8.3964 3.43139C9.59665 3.19264 10.8408 3.31518 11.9714 3.7835C13.102 4.25181 14.0683 5.04488 14.7482 6.06241C15.4281 7.07994 15.791 8.27623 15.791 9.5C15.7892 11.1405 15.1367 12.7132 13.9767 13.8732C12.8167 15.0331 11.244 15.6856 9.60352 15.6875ZM12.9785 9.5C12.9785 9.64918 12.9193 9.79226 12.8138 9.89775C12.7083 10.0032 12.5652 10.0625 12.416 10.0625H10.166V12.3125C10.166 12.4617 10.1068 12.6048 10.0013 12.7102C9.89578 12.8157 9.7527 12.875 9.60352 12.875C9.45433 12.875 9.31126 12.8157 9.20577 12.7102C9.10028 12.6048 9.04102 12.4617 9.04102 12.3125V10.0625H6.79102C6.64183 10.0625 6.49876 10.0032 6.39327 9.89775C6.28778 9.79226 6.22852 9.64918 6.22852 9.5C6.22852 9.35082 6.28778 9.20774 6.39327 9.10225C6.49876 8.99676 6.64183 8.9375 6.79102 8.9375H9.04102V6.6875C9.04102 6.53832 9.10028 6.39524 9.20577 6.28975C9.31126 6.18426 9.45433 6.125 9.60352 6.125C9.7527 6.125 9.89578 6.18426 10.0013 6.28975C10.1068 6.39524 10.166 6.53832 10.166 6.6875V8.9375H12.416C12.5652 8.9375 12.7083 8.99676 12.8138 9.10225C12.9193 9.20774 12.9785 9.35082 12.9785 9.5Z" fill="#434A60" />
                        </svg> Add New Card
                      </button>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    {savedCards?.map((savedCard: any) => (
                      <Grid item xs={12} sm={12} md={6} lg={6} key={savedCard.Id}>
                        <Card sx={{ borderRadius: 1 }}>
                          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
                            <Table>
                              <TableRow>
                                <TableCell>Status</TableCell>
                                <TableCell sx={{ px: 0 }} align="right">
                                  {savedCard.Default && checkDateValidity(savedCard) && (
                                    <button className="btn-default">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 18 18" fill="none" style={{ marginRight: '0.1rem' }}>
                                        <path d="M16.1483 5.46029L7.14828 14.4603C7.09604 14.5126 7.034 14.5541 6.96572 14.5824C6.89743 14.6107 6.82423 14.6253 6.75031 14.6253C6.67639 14.6253 6.6032 14.6107 6.53491 14.5824C6.46662 14.5541 6.40459 14.5126 6.35234 14.4603L2.41484 10.5228C2.3093 10.4172 2.25 10.2741 2.25 10.1248C2.25 9.97556 2.3093 9.8324 2.41484 9.72686C2.52039 9.62131 2.66355 9.56201 2.81281 9.56201C2.96208 9.56201 3.10523 9.62131 3.21078 9.72686L6.75031 13.2671L15.3523 4.66436C15.4579 4.55881 15.601 4.49951 15.7503 4.49951C15.8996 4.49951 16.0427 4.55881 16.1483 4.66436C16.2538 4.7699 16.3131 4.91306 16.3131 5.06232C16.3131 5.21159 16.2538 5.35475 16.1483 5.46029Z" fill="white" />
                                      </svg>
                                      Default
                                    </button>
                                  )}
                                  {!savedCard.Default && checkDateValidity(savedCard) && (
                                    <button
                                      className="btn-outline-no-fill"
                                      onClick={() => { makeCardDefault(savedCard) }}
                                    >
                                      <CircleCheck className="me-1" width={14} height={14} /> Make Default
                                    </button>
                                  )}
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>Card Type</TableCell>
                                <TableCell>{savedCard.CcType}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>Card number</TableCell>
                                <TableCell>**** {savedCard.CcLastFourDigits}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>Exp</TableCell>
                                <TableCell>{savedCard.CcExpMonth}/{savedCard.CcExpYear}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Link
                                    color="#1D89D2"
                                    onClick={() => {
                                      navigate("/account-settings-billing", {
                                        state: { paymentId: savedCard.Id },
                                      });
                                    }}
                                    sx={{ cursor: 'pointer', fontSize: '12px', textDecoration: 'underline' }}
                                  >
                                    Change Billing Address
                                  </Link>
                                </TableCell>
                                <TableCell>
                                  <Link
                                    color="#1D89D2"
                                    onClick={() => makeCardDeactivate(savedCard)}
                                    sx={{ cursor: 'pointer', fontSize: '12px', textDecoration: 'underline' }}
                                  >
                                    Deactivate Card
                                  </Link>
                                </TableCell>
                              </TableRow>
                            </Table>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>

                  {flagList?.featurePaymentHistory && (
                    <>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          color: "#212636",
                          fontSize: "15px",
                          mt: 4,
                          mb: 2
                        }}
                      >
                        Payment History
                      </Typography>

                      <Typography sx={{ fontSize: "12px", mb: 3 }}>
                        If you've just made a payment, it may take a few hours for it to appear in the table below.
                      </Typography>

                      <Grid container>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Date</TableCell>
                              <TableCell>Total</TableCell>
                              <TableCell>Service</TableCell>
                              <TableCell>Payment Method</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableRow>
                            <TableCell>08/13/2024</TableCell>
                            <TableCell>$49.99</TableCell>
                            <TableCell>Tax Shield</TableCell>
                            <TableCell>1111</TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </>
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Container>

      <Footer />

      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header className="ms-auto border-0 color-primary">
          <FaRegWindowClose onClick={handleClose} />
        </Modal.Header>
        <Modal.Body className="px-5">
          <h5 style={{ textAlign: "center" }}>
            Are You Sure You Want to Change Your Default Payment Method?
          </h5>
          <div className="d-block mx-auto  text-center">
            <button className="btn-continue mt-4 mb-3" onClick={saveDefaultCard}>
              Yes, Change Default
            </button>
            <span
              className="color-primary  text-decoration-underline d-block mx-auto fw-bold ff-Montserrat cursor-pointer"
              onClick={handleClose}
            >
              No, Cancel Change
            </span>
          </div>
        </Modal.Body>
      </Modal>

      <Modal centered show={view} onHide={handleCloseView}>
        <Modal.Header className="ms-auto border-0 color-primary">
          <FaRegWindowClose onClick={handleCloseView} />
        </Modal.Header>
        <Modal.Body className="px-5">
          <h5 style={{ textAlign: "center" }}>
            Are You Sure You Want to Deactivate This Card?
          </h5>
          <div className="d-block mx-auto  text-center">
            <button className="btn-continue mt-4 mb-3" onClick={saveDeactivateCard}>
              Yes, Deactivate Card
            </button>
            <span
              className="color-primary  text-decoration-underline d-block mx-auto fw-bold ff-Montserrat cursor-pointer"
              onClick={handleCloseView}
            >
              No, Cancel Change
            </span>
          </div>
        </Modal.Body>
      </Modal>

      <Modal centered show={showDefaultErrorModal} onHide={handleCloseDefaultErrorModal}>
        <Modal.Header className="ms-auto border-0 color-primary">
          <FaRegWindowClose onClick={handleCloseDefaultErrorModal} />
        </Modal.Header>
        <Modal.Body className="px-5">
          <h5 style={{ textAlign: "center" }}>
            You cannot deactivate the default card. Please change the default status and try again.
          </h5>
          <div className="d-block mx-auto  text-center">
            <button className="btn-continue mt-4 mb-3" onClick={handleCloseDefaultErrorModal}>
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ClientBillingInformation;
